<template>
  <div
    v-if="!usespan"
    class="image"
    :style="{ width: width }"
    :class="{ 'image--centered': centered }"
  >
    <img :src="imageURL" />
    <p v-if="description">{{ description }}</p>
  </div>
  <span v-else class="image" :style="{ width: width }" :class="{ 'image--centered': centered }">
    <img :width="width" :src="imageURL" />
    <p v-if="description">{{ description }}</p>
  </span>
</template>

<script>
export default {
  name: 'BlobImage',
  props: {
    usespan: {
      type: Boolean,
      default: false,
    },
    ignorePathBase: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
    },
    description: {
      type: String,
    },
    width: {
      type: String,
      default: '100%',
    },
    centered: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseStorage: process.env.VUE_APP_CDN,
    };
  },
  computed: {
    imageURL() {
      if (this.ignorePathBase) {
        return this.src;
      }
      return this.baseStorage + this.src;
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  &--centered {
    margin: 0 auto;
    text-align: center;
  }
  img {
    max-width: 100%;
  }
  .description {
    color: #2d3138;
  }
}
</style>
